import NoReviews, { NoReviewsProps } from './NoReviews'

export default NoReviews

export { NoReviews }
export type { NoReviewsProps }
